export default "__VITE_ASSET__b9c7e022__"